module.exports = __webpack_public_path__ + "static/media/assistencia-300x300.ee0d3be6.png";